/**
 * Identify whether or not we're in the Shopify theme editor
 */
export const isShopifyEditor = () => typeof window !== 'undefined' && window.Shopify?.designMode;
